/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type { GetAccountLanguageQueryResponse } from '../types/GetAccountLanguage.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getGetAccountLanguageUrl() {
  const res = { method: 'GET', url: `/account/language` as const };
  return res;
}

/**
 * @description Get account language preference
 * @summary Get account language preference
 * {@link /account/language}
 */
export async function getAccountLanguage(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetAccountLanguageQueryResponse, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetAccountLanguageUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
